<app-form-input  [label]="step7.getlangec"
	[name]="getUid() + '_SepAtt_langEC'" [parentForm]="parentForm" [disabled]="disabled"
	[type]="'chips'" [rule]="'pattern_32'" [value]="langue?.langEC"
	[autoCompleteType]="'LANGEC'" [autoCompleteTypeIndex]="0">
</app-form-input>

<app-form-input 
[parentForm]="parentForm"
[disabled]="disabled"
 
[value]="langue?.langAutre" 
 
[label]="step7.getlangautre"
[type]="'text'" [rule]="'minSize_1|maxSize_255'"
[name]="getUid()+'_SepAtt_langAutre'">
</app-form-input>
